import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { trackEvent } from "../../lib/analytics";
import { useLang } from "../../lib/LanguageContext";

const WA_NUMBER = "62881027917576"; // no + or spaces
const WA_MSG = {
  id: "Halo AsiaCommerce! Saya tertarik dengan produk grosir Anda.",
  en: "Hi AsiaCommerce! I'm interested in your wholesale products.",
};

export default function WhatsAppWidget() {
  const { lang } = useLang();
  const [bubbleOpen, setBubbleOpen] = useState(false);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShown(true), 1500);
    const b = setTimeout(() => setBubbleOpen(true), 4500);
    const h = setTimeout(() => setBubbleOpen(false), 12000);
    return () => {
      clearTimeout(t);
      clearTimeout(b);
      clearTimeout(h);
    };
  }, []);

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MSG[lang] || WA_MSG.id)}`;

  const onClick = () => {
    trackEvent("whatsapp_click", { source: "floating-widget" });
  };

  return (
    <div
      className={`fixed bottom-5 right-5 z-40 transition-all duration-500 ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="whatsapp-widget"
      style={{ marginBottom: 10 }}
    >
      {bubbleOpen && (
        <div className="mb-3 max-w-[260px] bg-white rounded-2xl border border-soft soft-shadow p-4 relative animate-fade-up">
          <button
            onClick={() => setBubbleOpen(false)}
            className="absolute top-2 right-2 text-ink-muted hover:text-ink"
            aria-label="close"
            data-testid="wa-close-bubble"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-2 mb-1.5">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
            <span className="text-xs font-semibold text-green-600">
              {lang === "id" ? "Tim kami online" : "Our team is online"}
            </span>
          </div>
          <p className="text-sm text-ink leading-snug">
            {lang === "id"
              ? "Ada pertanyaan seputar katalog atau cara mulai? Chat langsung lewat WhatsApp."
              : "Questions about the catalog or how to start? Chat us on WhatsApp."}
          </p>
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        data-testid="whatsapp-btn"
        className="flex items-center gap-2 h-14 px-5 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white font-semibold soft-shadow transition-all hover:-translate-y-0.5"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={2.4} fill="currentColor" />
        <span className="hidden sm:inline text-sm">
          {lang === "id" ? "Chat WhatsApp" : "Chat WhatsApp"}
        </span>
      </a>
    </div>
  );
}
